import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import "./styles.css";
import "./styles-v2.css";

createApp(App).use(createPinia()).mount("#app");
